import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import styles from './ForgotPassword.module.css';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);

        try {
            await axios.post(`${process.env.REACT_APP_API_URL}/api/c/passwordresetrequest/`, { email: email.toLowerCase() });
            setSuccess(true);
        } catch (err) {
            if (!err.response) {
                setError("Unable to connect to server. Please try again later.");
            } else {
                setError("Something went wrong. Please try again.");
            }
        } finally {
            setLoading(false);
        }
    };

    if (success) {
        return (
            <div className={styles.container}>
                <h2 className={styles.title}>Check your email</h2>
                <p className={styles.successMessage}>
                    If an account with that email exists, we sent a reset link. Check your inbox.
                </p>
                <button className={styles.submitButton} onClick={() => navigate('/login')}>
                    Back to Login
                </button>
            </div>
        );
    }

    return (
        <div className={styles.container}>
            <button className={styles.backButton} onClick={() => navigate('/login')}>← Back</button>
            <h2 className={styles.title}>Forgot Password</h2>
            <p className={styles.subtitle}>Enter your email and we'll send you a reset link.</p>
            <form className={styles.form} onSubmit={handleSubmit}>
                <label className={styles.label}>
                    Email
                    <input
                        className={styles.input}
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        autoFocus
                        autoComplete="email"
                        required
                    />
                </label>
                {error && <p className={styles.errorMessage}>{error}</p>}
                <button
                    className={styles.submitButton}
                    type="submit"
                    disabled={loading}
                >
                    {loading ? 'Sending…' : 'Send Reset Link'}
                </button>
            </form>
        </div>
    );
};

export default ForgotPassword;
